import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
    NgModule,
    LOCALE_ID,
    ErrorHandler,
    APP_INITIALIZER,
} from '@angular/core';
/* import localeES from '@angular/common/locales/es-CO';
import { registerLocaleData } from '@angular/common'; */
import {
    HttpClientModule,
    HTTP_INTERCEPTORS,
    HttpClient,
} from '@angular/common/http';
import { TokenInterceptor } from './common/interceptors/token.interceptor';
import { AuthorizationInterceptor } from './common/interceptors/authorization.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { PageNotFoundComponent } from './pagenotfound/pagenotfound.component';
import { LoginComponent } from './seguridad/login/login.component';
import { HomeComponent } from './proyecto/home.component';
import { SharedModule } from './shared/shared.module';
import { SearchPipeNombre } from './common/pipes/search';
import localeES from '@angular/common/locales/es-CO';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import { MyDatePipe } from '../app/common/pipes/dateFormatPipe';
import { MoneyPipe } from './common/pipes/moneyFormat';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { EscalaPipe } from './common/pipes/escalaPipe';
import { MinValueValidator } from './common/directives/min-value-validator.directive';
import { MaxValueValidator } from './common/directives/max-value-validator.directive';
import { ActualPipe } from './common/pipes/actual.pipe';
import { SpinnerComponent } from './common/components/spinner/spinner.component';
import { GlobalErrorService } from './common/error/global-error.service';
import { BarrasComponent } from './common/dashboard/barras/barras.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { menuProyectoComponent } from './layout/content/menu-proyecto/menu-proyecto.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ProductModule } from './producto/product.module';
import { EmpresaComponent } from './empresa/empresa-formulario/empresa.component';
import { MostrarFormularioComponent } from './empresa/page/mostrar-formulario/mostrar-formulario.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import localeEs from '@angular/common/locales/es';

import { DirUrbanaComponent } from './empresa/dir-urbana/dir-urbana.component';

import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './init/keycloak-init.factory';
import { ReporteModule } from './reporte/reporte.module';
import { NovedadesModule } from './novedades/novedades.module';
import { PresentationModule } from './presentacion/presentacion.module';
import { ViewSuccesComponent } from './components/view-succes/view-succes.component';
import { ReporteVentasComponent } from './reporte-ventas-individual/reporte-ventas.component';
import { EditEmpresaComponent } from './empresa/editar-empresa/edit-empresa/edit-empresa.component';
import { EditDireccionComponent } from './empresa/editar-empresa/edit-direccion/edit-direccion.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BusquedaUsuarioComponent } from './administrador/busqueda-usuario/busqueda-usuario.component';
import { BusquedaEmpresaComponent } from './administrador/busqueda-empresa/busqueda-empresa.component';
import { RepresentanteAgenteVigiladoComponent } from './representante-agente-vigilado/representante-agente-vigilado.component';
import { TablerosBiComponent } from './administrador/tableros-bi/tableros-bi.component';
import { ViewRepresentanteComponent } from './representante-agente-vigilado/utils/view-representante-succes';
import { RepresentanteUsuarioComponent } from './representante-agente-vigilado/representante-usuario/editar.representante-usuario';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CargaEmpresasComponent } from './carga-empresas/carga-empresas.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CargaMasivaProductosComponent } from './carga-masiva-productos/carga-masiva-productos.component';
import { TableCargaMasivaComponent } from './carga-masiva-productos/table-carga-masiva/table-carga-masiva.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ViewDireccionModalComponent } from './administrador/busqueda-usuario/modals/view-direccion-modal.component';
import { ViewEmpresaModalComponent } from './administrador/busqueda-usuario/modals/view-empresa-modal.component';
import { ViewRepresentanteModalComponent } from './administrador/busqueda-usuario/modals/view-representante-modal.component';
import { ReportFilterSemesterDevComponent } from './novedad-filtro-semestre/report-filter-semester-dev.component';
import { ParametrosComponent } from './administrador/parametros/parametros.component';
import { ComercializadorComponent } from './empresa/comercializador/comercializador.component';
import { DeactivationReasonModalComponent } from './administrador/busqueda-empresa/modals/deactivation-reason-modal/deactivation-reason-modal.component';
import { SemesterPickerComponent } from './novedad-filtro-semestre/components/semester-picker/semester-picker.component';
import { AccessControlService } from './access-control/services/access-control.service';
import { RegistroService } from './registro.service';
import { IconoFiltroComponent } from 'src/app/common/components/icono-filtro/icono-filtro.component';
import { EditRolModalComponent } from './administrador/busqueda-usuario/modals/edit-rol-modal/edit-rol-modal.component';
import { ButtonComponent } from './shared/components/button/button.component';
import { ReporteCumplimientoProductorComponent } from './reporte-cumplimiento-productor/reporte-cumplimiento-productor.component';
import { InactivarUsuarioModalComponent } from './administrador/busqueda-usuario/modals/inactivar-usuario-modal/inactivar-usuario-modal.component';
import { VerUsuarioModalComponent } from './administrador/busqueda-usuario/modals/ver-usuario-modal/ver-usuario-modal.component';
import { CargaReportesMadrComponent } from './administrador/carga-reportes-madr/carga-reportes-madr.component';
import { ConsultaReportesMadrComponent } from './administrador/consulta-reportes-madr/consulta-reportes-madr.component';
import { EditaMasivaProductosComponent } from './administrador/edita-masiva-productos/edita-masiva-productos.component';

registerLocaleData(localeES, 'es-CO');
// Función de carga de traducción
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        PageNotFoundComponent,
        HomeComponent,
        SearchPipeNombre,
        MoneyPipe,
        EscalaPipe,
        MinValueValidator,
        MaxValueValidator,
        ActualPipe,
        SpinnerComponent,
        BarrasComponent,
        menuProyectoComponent,
        EmpresaComponent,
        MostrarFormularioComponent,
        DirUrbanaComponent,
        ViewSuccesComponent,
        ReporteVentasComponent,
        EditEmpresaComponent,
        EditDireccionComponent,
        ReportFilterSemesterDevComponent,
        BusquedaUsuarioComponent,
        BusquedaEmpresaComponent,
        RepresentanteAgenteVigiladoComponent,
        TablerosBiComponent,
        ViewRepresentanteComponent,
        RepresentanteUsuarioComponent,
        CargaEmpresasComponent,
        CargaMasivaProductosComponent,
        TableCargaMasivaComponent,
        ViewDireccionModalComponent,
        ViewEmpresaModalComponent,
        ViewRepresentanteModalComponent,
        ParametrosComponent,
        ComercializadorComponent,
        DeactivationReasonModalComponent,
        EditRolModalComponent,
        ReporteCumplimientoProductorComponent,
        InactivarUsuarioModalComponent,
        VerUsuarioModalComponent,
        CargaReportesMadrComponent,
        ConsultaReportesMadrComponent,
        EditaMasivaProductosComponent,
    ],
    imports: [
        BrowserModule,
        ProductModule,
        PresentationModule,
        ReporteModule,
        NovedadesModule,
        AppRoutingModule,
        LayoutModule,
        SharedModule,
        HttpClientModule,
        BrowserAnimationsModule,
        FontAwesomeModule,
        FormsModule,
        NgSelectModule,
        ReactiveFormsModule,
        FormsModule,
        KeycloakAngularModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMaskDirective,
        NgxMaskPipe,
        TranslateModule.forRoot(),
        SemesterPickerComponent,
        IconoFiltroComponent,
        ButtonComponent,
    ],
    exports: [SearchPipeNombre],
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorService,
        },
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: LOCALE_ID, useValue: 'es-CO' },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthorizationInterceptor,
            multi: true,
        },
        { provide: MyDatePipe },
        { provide: MoneyPipe },
        { provide: DecimalPipe },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService, AccessControlService, RegistroService],
        },
        EscalaPipe,
        provideNgxMask({
            thousandSeparator: '.', // Configuracioón el separador de miles como punto
            decimalMarker: ',', // Configuración el marcador decimal como coma
        }),
        {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
